import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "htmlTag", "recordId", "query", "propsToDisplay", "elementTitle", "loopProperties", "loopLimit", "VariantComponent", "isSlider"];
import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { summaryComponents } from './DataSummaryTypes';
import { getClassModifiers } from '../../utils';
import { buildPropsToDisplayWithContent, stripSummaryPropsContent, buildLoopPropsContent } from './helpers';
import { parsePropsToDisplay } from '../../helpers';
const DataSummaryRender = _ref => {
  let {
      type,
      htmlTag,
      recordId,
      query,
      propsToDisplay,
      elementTitle,
      loopProperties,
      loopLimit,
      VariantComponent,
      isSlider
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const SummaryComponent = summaryComponents[type];
  const {
    data,
    error,
    loading
  } = useQuery(query, {
    variables: {
      id: recordId
    }
  });
  if (loading) return '';
  if (error) return error.message;
  if (!data || !data.entityData) return null;
  const {
    entityData
  } = data;
  const shouldLoop = loopProperties && loopProperties.length;
  const modifier = getClassModifiers('list', otherProps);
  const summaryPropsWithContent = shouldLoop ? buildLoopPropsContent(loopProperties, propsToDisplay, loopLimit, entityData, isSlider) : buildPropsToDisplayWithContent(entityData, propsToDisplay);
  const summaryPropsWithCleanContent = stripSummaryPropsContent(propsToDisplay, summaryPropsWithContent);
  const parsedPropsToDisplay = parsePropsToDisplay(entityData, propsToDisplay);
  if (!summaryPropsWithCleanContent.length) return null;
  if (VariantComponent) return /*#__PURE__*/React.createElement(VariantComponent, _extends({}, otherProps, {
    propsToDisplay: propsToDisplay,
    summaryPropsWithContent: summaryPropsWithCleanContent,
    parsedPropsToDisplay: parsedPropsToDisplay
  }), summaryPropsWithContent.map(summaryProps => /*#__PURE__*/React.createElement(SummaryComponent, {
    modifier: modifier,
    elementTitle: elementTitle,
    summaryPropsWithContent: summaryProps,
    htmlTag: htmlTag
  })));
  return /*#__PURE__*/React.createElement(SummaryComponent, {
    modifier: modifier,
    elementTitle: elementTitle,
    summaryPropsWithContent: summaryPropsWithCleanContent,
    htmlTag: htmlTag
  });
};
DataSummaryRender.propTypes = {
  entities: PropTypes.array.isRequired,
  mainSchemas: PropTypes.object.isRequired,
  isSlider: PropTypes.bool.isRequired,
  type: PropTypes.string,
  name: PropTypes.string,
  query: PropTypes.object,
  recordId: PropTypes.string,
  propsToDisplay: PropTypes.array,
  elementTitle: PropTypes.string,
  htmlTag: PropTypes.string,
  loopProperties: PropTypes.array,
  loopLimit: PropTypes.number,
  VariantComponent: PropTypes.func
};
DataSummaryRender.defaultProps = {
  name: '',
  type: 'text',
  query: {},
  recordId: '',
  propsToDisplay: [],
  elementTitle: '',
  htmlTag: 'h2',
  loopProperties: [],
  loopLimit: 0,
  VariantComponent: null
};
export default DataSummaryRender;
//# sourceMappingURL=DataSummaryRender.js.map